import '@scss/landing/promo/brand_visibility.scss';
import { Router } from "@js/common/router";
import { sendForm } from "@js/common/contactForm";
import { initCaptcha } from "@js/landing/hcaptcha";
document.addEventListener('DOMContentLoaded', function () {
    sendContactForm();
});
var sendContactForm = function () {
    var form = document.querySelector('#contactForm');
    var button = form.querySelector('#contactButton');
    if (!form || !button) {
        return;
    }
    var captchaToken = '';
    initCaptcha().then(function (token) {
        captchaToken = token;
    });
    button.addEventListener('click', function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var firstName = (_a = form.querySelector('#firstname')) === null || _a === void 0 ? void 0 : _a.value;
        var lastName = (_b = form.querySelector('#lastname')) === null || _b === void 0 ? void 0 : _b.value;
        var workEmailAddress = (_c = form.querySelector('#workEmailAddress')) === null || _c === void 0 ? void 0 : _c.value;
        var workPhoneNumber = (_d = form.querySelector('#workPhoneNumber')) === null || _d === void 0 ? void 0 : _d.value;
        var company = (_e = form.querySelector('#company')) === null || _e === void 0 ? void 0 : _e.value;
        var jobTitle = (_f = form.querySelector('#jobTitle')) === null || _f === void 0 ? void 0 : _f.value;
        var interest = (_g = form.querySelector('#interest')) === null || _g === void 0 ? void 0 : _g.value;
        var comment = (_h = form.querySelector('#comment')) === null || _h === void 0 ? void 0 : _h.value;
        var country = (_j = form.querySelector('#country')) === null || _j === void 0 ? void 0 : _j.value;
        var body = {
            'first_name': firstName,
            'last_name': lastName,
            'email': workEmailAddress,
            'phone_number': workPhoneNumber,
            'company': company,
            'job_title': jobTitle,
            'interest': interest,
            'country': country,
            'comment': comment,
            'h-captcha-response': captchaToken,
        };
        var path = Router.generate('brand_visibility_contact_create');
        sendForm(form, button, path, body);
    });
};
